import { openZohoChat } from '../utils/openZohoChat';
import './FreeSupport.css';

export default function FreeSupport() {
  return (
    <section className="dh-free">
      <div className="dh-container dh-free__grid">
        <div className="dh-free__media">
          <img
            src="/images/agent.jpg"
            alt="Dragon Help agent available for free technical support"
            width="480"
            height="520"
          />
        </div>
        <div className="dh-free__copy">
          <h2>Free Dragon technical support for Dragon NaturallySpeaking.</h2>
          <p>
            From first-time installs to stubborn error codes, our team helps you get back to accurate
            dictation quickly. Share your Dragon version and what you see on screen — we will guide the
            next steps live.
          </p>
          <button type="button" className="dh-btn dh-btn--outline" onClick={openZohoChat}>
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
}
